import profile from './profile';

export default {
  namespaced: true,
  modules   : {
    profile,
  },
  state: () => ({
  }),
  mutations: {
  },
  actions: {
  },
};
